// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__IkTtq","logoLink":"Layout_logoLink__Pkjfg"};